var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailUnread = function SvgEmailUnread(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 21,
    viewBox: "0 0 20.8 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.25 4a2.25 2.25 0 0 1 2.25 2.25v9.5A2.25 2.25 0 0 1 15.25 18h-13A2.25 2.25 0 0 1 0 15.75v-9.5A2.25 2.25 0 0 1 2.25 4zm-6.07 8.11a.76.76 0 0 1-.43.14.76.76 0 0 1-.43-.14L1.5 7.27v8.48a.76.76 0 0 0 .75.75h13a.76.76 0 0 0 .75-.75V7.27zM2.25 5.5a.76.76 0 0 0-.446.154L8.75 10.58l6.945-4.926a.76.76 0 0 0-.445-.154z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.75 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailUnread);
export default ForwardRef;